// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import * as angular from 'angular';
import { SmartTable } from '../../../../components/smart-table/smart-table.model';
import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';

/** @ngInject */
export function Controller(
    $rootScope,
    $scope,
    $state,
    $translate,
    AccountsResource,
    Alert,
    CompanyUser,
    ConfirmDeleteModal,
    Groups,
    GroupsResource,
    UserAccounts,
) {
    this.$onInit = () => {
    const companyId = $state.params.companyId;
    $scope.companyId = companyId;
    $scope.username = $state.params.username;
    $scope.step = "step0";
    $scope.dropdownIsOpen = false;
    $scope.searchValue = "";
    $scope.groupApplicationsMap = {};
    $scope.st = new SmartTable();

    function initUsers(goToStep0){
        
        $scope.userSharedAccounts = UserAccounts.getSharedEmailAccountsByUsername({
            companyId : companyId,
            username : $scope.username
        }, function(data) {
            $scope.userSharedAccounts = data;
            if($scope.selectedSaaspassId !== null){
                if(goToStep0){
                    $scope.cancleSearch();
                }
                $scope.selectSaaspassId($scope.selectedSaaspassId);
            }
            if(data.length==0){
                $state.go('company.sharing-center.shared-accounts',{},{reload:true});
            }else{
                if(goToStep0){
                    $scope.step = "step0";  
                }
            }
        });
    };
    
    $scope.selectSaaspassId = function(saaspassId){

        $scope.shareWithAnotherUserButtonClicked = false;
        $scope.selectedSaaspassId = saaspassId;
        $scope.step = "step_user_already_exist";
        var tmpAccount = userExists(saaspassId);
        if(tmpAccount){
            $scope.account = tmpAccount;
            $scope.resourceIds = {
                companyId: companyId,
                id: tmpAccount.id
            };
            getOtherCompanyUserAccounts();
            loadGroups();
        }
    }
    
    $scope.shareWithAnotherUser = function(){
        identifyUser($scope.newUserIdentifier1);
    }
    
    $scope.onSearchStart = function(keyEvent) {
        $scope.shareWithAnotherUserButtonClicked = false;
        if (keyEvent.which === 13){
            identifyUser($scope.newUserIdentifier2);
        }
    }
    
    $scope.cancleSearch = function(){
        $scope.userIdentifier = null;
        $scope.newUserIdentifier1 = null;
        $scope.newUserIdentifier2 = null;
        $scope.successResult = null;
        $scope.showVerification = false;
        $scope.companyUser = null;
        $scope.message = null;
        $scope.newUserIdentifier = null;
        if(!$scope.shareWithAnotherUserButtonClicked){
            $scope.step = "step0";
        }
    }
    
    $scope.share = function(saaspassId){
        if($scope.isSendingRequest){
            return;
        }
        $scope.isSendingRequest = true;
        
        var param = {
                companyId: companyId
        }
        var dataReq = {
                username: $scope.username,
                companyUser: $scope.companyUser
        }
        
        UserAccounts.createSharedUserAccount(param, dataReq, function(data){
            AccountsResource.getAllGroupsForUserAccount(companyId, data.id).then((groups) => {
                $scope.groupsOfUser = groups.filter((group) => group.type !== 'EVERYONE');
            });
            $scope.username = data.username;
            const key = 'groups_users.added_active_account_SHARED_EMAIL';
            const variables = {saaspassId: data.companyUser.saaspassUser.saaspassId};
            $scope.globalTopLevelMessage = new SpAlert('success', key, variables);
            $scope.selectedSaaspassId = saaspassId;
            initUsers(true);
            $scope.cancleSearch();
            $scope.isSendingRequest = false;
            
        }, function(error){
            $scope.isSendingRequest = false;
        })
        
    }
    
    
    var userExists = function(saaspassId){
        for(var i=0;i<$scope.userSharedAccounts.length;i++){
            if($scope.userSharedAccounts[i].companyUser.saaspassUser.saaspassId == saaspassId){
                return $scope.userSharedAccounts[i];
            }
        }
        return null;
    }
    
    $scope.doesUserExists = function(saaspassId){
        var result = userExists(saaspassId) !== null;
        return result;
    }
    
    
    var identifyUser = function(identifier) {
            $scope.userIdentifier = identifier;

            if ($scope.userIdentifier == $scope.currentSaaspassId) {
                $scope.successResult = false;
                $scope.showVerification = false;

                $scope.message = 'groups_users.user_is_the_same';
            } else if ($scope.userIdentifier == $scope.currentEmailAddress) {
                $scope.successResult = false;
                $scope.showVerification = false;

                $scope.message = 'groups_users.user_email_is_the_same';
            } else {
                CompanyUser.identifyCompanyUser({
                    companyId : companyId,
                    uid : encodeURIComponent($scope.userIdentifier)
                }, function(data) {
                    if ((data.id && data.id == $scope.currentCompanyUserId) ||
                            (data.saaspassUser && data.saaspassUser.id == $scope.currentSaaspassId)) {
                        $scope.successResult = false;
                        $scope.showVerification = false;
                        $scope.step = "user_not_found";
                        $scope.message = 'groups_users.user_is_the_same';
                    } else {
                        
                        if(userExists(data.saaspassUser.saaspassId) && !$scope.shareWithAnotherUserButtonClicked){
                            $scope.cancleSearch();
                            $scope.selectSaaspassId(data.saaspassUser.saaspassId);
                        }else{
                            $scope.step = "step_user_found";
                            $scope.successResult = true;
                            $scope.showVerification = false;
                            $scope.companyUser = data;
    
                            $scope.message = 'groups_users.user_found';
                        }
                    }
                }, function(error) {
                    $scope.successResult = false;
                    $scope.companyUser = null;

                    $scope.showVerification = $scope.enableVerification && !$scope.successResult
                            && $rootScope.emailPattern.test($scope.userIdentifier);
                    
                    $scope.step = "step_user_not_found";
                    if (error.status == 404) {
                        $scope.message = $translate.instant('sharing_center.user_not_found') + ' ' + identifier;
                    } else {
                        $scope.message = error.data.message;
                    }
                });
            }
    }

    var getOtherCompanyUserAccounts = function(){
        var tmpAccount = userExists($scope.selectedSaaspassId);
        if(tmpAccount){
            var resourceIds = {
                companyId: companyId,
                id: tmpAccount.companyUser.id
            };
    
            CompanyUser.getUserAccounts(resourceIds, function (accounts) {
                $scope.accountsForCompanyUser = accounts;
            });
        }
    }
    
    var loadGroups = function() {

        AccountsResource
            .getAllGroupsForUserAccount($scope.resourceIds.companyId, $scope.resourceIds.id)
            .then((groupsAndApps) => groupsAndApps.map(({group}) => group))
            .then((groups) => {
            $scope.groupsOfUser = groups.filter((group) => group.type !== 'EVERYONE');

            angular.forEach($scope.groupsOfUser
            , function(group) {
                
                if (!$scope.groupApplicationsMap.hasOwnProperty(group.id)) {
                    GroupsResource
                        .getAssignedApplicationsOfGroup(companyId, group.id)
                        .then((applications) => {
                            $scope.groupApplicationsMap[group.id] = applications;
                        })
                }
            });
        });

        AccountsResource
            .getAllGroupsUserCanBeAssignedTo($scope.resourceIds.companyId, $scope.resourceIds.id)
            .then((data) => $scope.groupsForAdd = data);
    }
    
    $scope.removeUserFromGroups = function(groupId){
        AccountsResource
            .removeUserFromGroups($scope.resourceIds.companyId, $scope.resourceIds.id, [groupId])
            .then(() => {
                loadGroups();
                Alert('success', 'groups_users.remove_user_from_groups');
            });
    }
    
    $scope.assignToGroup = function(group) {
        AccountsResource
            .assignUserToGroups($scope.resourceIds.companyId, $scope.resourceIds.id, [group.id])
            .then(() => {
                loadGroups();
                Alert('success', 'groups_users.assign_to_group_success');
            });
    }
    
    $scope.canBeSelected = function(entity) {
        if (angular.isDefined(entity)) {
            return entity.type == "CUSTOM" || entity.type == "APPLICATION";
        }
        return false;
    }

    $scope.shareWithAdditionalUser = function(){
        $scope.cancleSearch();
        $scope.step = "share_with_additional_user";
        $scope.shareWithAnotherUserButtonClicked = true;
    }

    $scope.unshare = function(saaspassId){
        $scope.type = 'SINGLE';
        $scope.saaspassId = saaspassId;
        ConfirmDeleteModal('groups_users.confirm_shared_email_account_delete')
            .then(() => AccountsResource.deleteUserAccount($scope.resourceIds.companyId, $scope.resourceIds.id))
            .then(() => initUsers(true))
    };
    
    var loadUserAccountsForGroup = function(group) {
        GroupsResource
            .getAllAccountsForCompanyAndGroup(companyId, group.id)
            .then((userAccounts) => $scope.userAccounts = userAccounts);
    };
    
    $scope.showGroupData = function(groupType) {

        var group = Groups.getGroupsByType({
            companyId : companyId,
            type : groupType
        });
        group.$promise.then(function(data) {
            var firstGroup = data[0];
            loadUserAccountsForGroup(firstGroup);
        });
    };
    
    $scope.showGroupData('EVERYONE');

    $scope.customGroups = this.customGroups;

    $scope.applicationGroups = this.applicationGroups;
    
        $scope.userSharedAccounts = this.sharedAccounts;
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-company-account/shared-company-account.controller.js